import { isStandaloneDisplay } from "./pushNotifications";

export const INSTALL_ENGAGEMENT_KEY = "albis-install-engaged-v1";
export const INSTALL_PROMPT_DISMISSED_AT_KEY = "albis-install-prompt-dismissed-at-v1";
export const INSTALL_PROMPT_DISMISS_COUNT_KEY = "albis-install-prompt-dismiss-count-v1";
export const INSTALL_PROMPT_COMPLETE_KEY = "albis-install-prompt-complete-v1";
export const INSTALL_ENGAGEMENT_EVENT = "albis-install-engaged";

const DISMISS_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;
const MAX_AUTO_DISMISSALS = 3;

export function markInstallEngagement() {
  try {
    const had = Boolean(localStorage.getItem(INSTALL_ENGAGEMENT_KEY));
    localStorage.setItem(INSTALL_ENGAGEMENT_KEY, String(Date.now()));
    if (!had && typeof window !== "undefined") {
      window.dispatchEvent(new Event(INSTALL_ENGAGEMENT_EVENT));
    }
  } catch {
    /* ignore */
  }
}

export function hasInstallEngagement() {
  try {
    return Boolean(localStorage.getItem(INSTALL_ENGAGEMENT_KEY));
  } catch {
    return false;
  }
}

export function isInstallPromptComplete() {
  try {
    return localStorage.getItem(INSTALL_PROMPT_COMPLETE_KEY) === "1";
  } catch {
    return false;
  }
}

export function markInstallComplete() {
  try {
    localStorage.setItem(INSTALL_PROMPT_COMPLETE_KEY, "1");
    localStorage.removeItem(INSTALL_PROMPT_DISMISSED_AT_KEY);
    localStorage.removeItem(INSTALL_PROMPT_DISMISS_COUNT_KEY);
  } catch {
    /* ignore */
  }
}

export function getInstallDismissCount() {
  try {
    const n = parseInt(localStorage.getItem(INSTALL_PROMPT_DISMISS_COUNT_KEY) || "0", 10);
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
}

export function dismissInstallPrompt() {
  try {
    const count = getInstallDismissCount() + 1;
    localStorage.setItem(INSTALL_PROMPT_DISMISS_COUNT_KEY, String(count));
    localStorage.setItem(INSTALL_PROMPT_DISMISSED_AT_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
}

function isWithinDismissCooldown() {
  try {
    const raw = localStorage.getItem(INSTALL_PROMPT_DISMISSED_AT_KEY);
    if (!raw) return false;
    const dismissedAt = parseInt(raw, 10);
    if (!Number.isFinite(dismissedAt)) return false;
    return Date.now() - dismissedAt < DISMISS_COOLDOWN_MS;
  } catch {
    return false;
  }
}

export function isInstallAutoPromptExhausted() {
  return getInstallDismissCount() >= MAX_AUTO_DISMISSALS;
}

/**
 * @param {{ force?: boolean }} [options] force = user opened help from Mehr (bypass cooldown / exhaustion for manual view)
 */
export function shouldOfferInstallPrompt(options = {}) {
  const { force = false } = options;
  if (isStandaloneDisplay() || isInstallPromptComplete()) return false;
  if (!hasInstallEngagement()) return false;
  if (force) return true;
  if (isInstallAutoPromptExhausted()) return false;
  if (isWithinDismissCooldown()) return false;
  return true;
}
